// extracted by mini-css-extract-plugin
export default {"table":"table__vo71ct"};